import { trpc } from "@blis/trpc/react";

import { OrgsTable } from "../components/clients/ClientsTable";
import { Section } from "../components/Section";

export function ClientsPage() {
  const { data } = trpc.admin.org.list.useQuery();

  return (
    <>
      <Section.Title>Organizations</Section.Title>
      <OrgsTable orgs={data} />
    </>
  );
}
